var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { css } from 'styled-components';
import { buildDevProps } from '../../helpers/builders';
var buildDefaultProps = function (theme) {
    var today = {
        outlineColor: theme.brand.color.primary.pure,
        outlineWidth: theme.borderWidth.hairline,
        outlineStyle: 'solid',
        outlineOffset: -theme.borderWidth.hairline,
        borderRadius: theme.borderRadius.xs,
        fontWeight: theme.brand.fontWeight.bold,
    };
    var selected = {
        fontWeight: theme.brand.fontWeight.bold,
        backgroundColor: theme.brand.color.primary.pure,
        borderRadius: theme.borderRadius.xs,
    };
    var startRange = {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        right: 0,
    };
    var endRange = {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0,
        left: 0,
    };
    var dayBetweenRangeContainerStyle = {
        fontWeight: theme.brand.fontWeight.bold,
        // color: theme.brand.color.primary.pure,
        // FIXME: Add no core
        // background-color: ${theme.brand.color.primary.pure};
        backgroundColor: '#e9e6ff',
    };
    var datePickerContainerStyle = {
        fontFamily: theme.brand.fontFamily,
        fontWeight: theme.brand.fontWeight.medium,
        marginTop: theme.spacing.nano,
        backgroundColor: theme.neutrals.pureWhite,
        boxShadow: theme.brand.boxShadow.level2.replace(';', ''),
        border: "".concat(theme.borderWidth.hairline, "px solid ").concat(theme.neutrals.gray4),
        borderRadius: theme.borderRadius.sm,
    };
    var dayTextDefault = {
        cursor: 'pointer',
        fontSize: theme.fontSize.xxxs,
    };
    var dayTextSameMonth = __assign({ color: theme.neutrals.gray8 }, dayTextDefault);
    var dayTextDifferentMonth = __assign({ color: theme.neutrals.gray5 }, dayTextDefault);
    var dayTextSelected = __assign({ color: theme.neutrals.pureWhite }, dayTextDefault);
    var dayTextToday = __assign({ color: theme.brand.color.primary.pure }, dayTextDefault);
    var weekTextStyle = {
        color: theme.neutrals.gray5,
        fontSize: theme.fontSize.xxxs,
        fontWeight: theme.brand.fontWeight.medium,
        fontFamily: theme.brand.fontFamily,
    };
    var headerTextStyle = {
        color: theme.neutrals.gray8,
        fontSize: theme.fontSize.xxs,
        fontWeight: theme.brand.fontWeight.bold,
        fontFamily: theme.brand.fontFamily,
    };
    var headerIndicatorStyle = {
        color: theme.neutrals.gray8,
        size: theme.fixedHeight.xs,
    };
    var headerActionButtonStyle = {
        arrowIcon: {
            color: theme.neutrals.gray8,
            size: 12,
        },
        arrowContainer: {
            border: "".concat(theme.borderWidth.hairline, "px solid ").concat(theme.neutrals.pureBlack),
            borderRadius: theme.borderRadius.pill,
            height: theme.fixedHeight.xs,
            width: theme.fixedHeight.xs,
        },
    };
    return {
        datePickerContainerStyle: datePickerContainerStyle,
        dayContainerStyle: {
            today: today,
            selected: selected,
            startRange: startRange,
            endRange: endRange,
        },
        dayBetweenRangeContainerStyle: dayBetweenRangeContainerStyle,
        dayTextStyle: {
            sameMonth: dayTextSameMonth,
            differentMonth: dayTextDifferentMonth,
            selected: dayTextSelected,
            today: dayTextToday,
        },
        weekTextStyle: weekTextStyle,
        headerTextStyle: headerTextStyle,
        headerIndicatorStyle: headerIndicatorStyle,
        headerActionButtonStyle: headerActionButtonStyle,
    };
};
export var buildDatePickerProps = function (devProps, theme) {
    var defaultProps = buildDefaultProps(theme);
    return buildDevProps(defaultProps, devProps);
};
export var modifiers = {
    isFirst: function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n    right: 0;\n  "], ["\n    border-top-right-radius: 0px;\n    border-bottom-right-radius: 0px;\n    right: 0;\n  "]))); },
    isSecond: function () { return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    left: 0;\n  "], ["\n    border-top-left-radius: 0px;\n    border-bottom-left-radius: 0px;\n    left: 0;\n  "]))); },
};
var templateObject_1, templateObject_2;
